import {createContext} from 'react';
import {BiotwinCondition, RelevantCondition, RelevantConditionRelations} from '../../biotwin/types';

export interface PersonContextValue {
  biotwinConditions: BiotwinCondition[];
  contains: (conditionId1: number, conditionId2: number) => boolean;
  hasRelation: (conditionId1: number, conditionId2: number) => boolean;
  isOptionalRelated: (relevantCondition: number | RelevantCondition) => boolean;
  isRequiredRelated: (relevantCondition: number | RelevantCondition) => boolean;
  isSelected: (relevantCondition: number | RelevantCondition) => boolean;
  isSuggested: (relevantCondition: number | RelevantCondition) => boolean;
  relations: RelevantConditionRelations[];
  relationsByConditionId: Record<string, RelevantConditionRelations>;
  relevantConditions: RelevantCondition[] | null | undefined;
  relevantConditionsDeduplicated?: RelevantCondition[] | null | undefined;
  relevantConditionsOptionalRelated?: RelevantCondition[] | null | undefined;
  relevantConditionsRequiredRelated?: RelevantCondition[] | null | undefined;
  relevantConditionsSelected?: RelevantCondition[] | null | undefined;
  relevantConditionsSuggested?: RelevantCondition[] | null | undefined;
  userId: number;
}

const defaultPersonContextValue: PersonContextValue = {
  biotwinConditions: [],
  contains: () => false,
  hasRelation: () => false,
  isOptionalRelated: () => false,
  isRequiredRelated: () => false,
  isSelected: () => false,
  isSuggested: () => false,
  relations: [],
  relationsByConditionId: {},
  relevantConditions: null,
  relevantConditionsDeduplicated: null,
  relevantConditionsOptionalRelated: null,
  relevantConditionsRequiredRelated: null,
  relevantConditionsSelected: null,
  relevantConditionsSuggested: null,
  userId: 0,
};

export const PersonContext = createContext<PersonContextValue>(defaultPersonContextValue);
